import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
    static values = {
        url: String,
    };

    declare readonly urlValue: string;
    declare readonly hasUrlValue: boolean;

    private delayTimerId: number | null = null;
    private idleCallbackId: number | null = null;

    connect(): void {
        if (!this.hasUrlValue || !window.htmx?.ajax) {
            return;
        }

        // Trace links are diagnostic-only. Keep their Flipt/SQL work out of the
        // visible ticket transition and wait until detail/chat have had time to
        // settle before using an idle slice.
        this.delayTimerId = window.setTimeout(() => {
            this.delayTimerId = null;
            if (typeof window.requestIdleCallback === "function") {
                this.idleCallbackId = window.requestIdleCallback(
                    () => {
                        this.idleCallbackId = null;
                        this.load();
                    },
                    { timeout: 1_000 },
                );
                return;
            }

            this.load();
        }, 1_000);
    }

    disconnect(): void {
        if (this.delayTimerId !== null) {
            window.clearTimeout(this.delayTimerId);
            this.delayTimerId = null;
        }
        if (this.idleCallbackId !== null && typeof window.cancelIdleCallback === "function") {
            window.cancelIdleCallback(this.idleCallbackId);
            this.idleCallbackId = null;
        }
    }

    private load(): void {
        const ajax = window.htmx?.ajax;
        if (!this.element.isConnected || !this.hasUrlValue || !ajax) {
            return;
        }

        void Promise.resolve(ajax("GET", this.urlValue, {
            source: this.element,
            target: this.element,
            swap: "outerHTML",
        })).catch(error => console.warn("[ticket-detail-langfuse] request failed", error));
    }
}
